// ─────────────────────────────────────────────────────────────────────────────
// firebase.js
//
// Single point of Firebase initialization. Adds Auth, Firestore, and App Check
// to the Firebase project that hosts the palette Storage bucket.
//
// App Check attests that requests come from the real app (not a script using the
// public config), protecting the Cloud Functions / AI proxy from abuse. It must
// initialize right after initializeApp and before any service (auth/firestore/
// functions) is used.
//
// IMPORTANT: the firebaseConfig values are not secrets — they identify the
// project but grant no access. The reCAPTCHA SITE key below is likewise public
// (it ships in the bundle by design). The reCAPTCHA SECRET key is NOT here; it
// lives only in the Firebase console App Check registration.
// ─────────────────────────────────────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAE56dpli8tsyAncybBPHPdO9uM1B9KfgY",
  authDomain: "plato-s-playground-591ed.firebaseapp.com",
  projectId: "plato-s-playground-591ed",
  storageBucket: "plato-s-playground-591ed.firebasestorage.app",
  messagingSenderId: "144850745484",
  appId: "1:144850745484:web:baa766d6a2abdde892e3a9"
};

const app = initializeApp(firebaseConfig);

// On localhost, enable the App Check debug provider. This makes the SDK print a
// debug token to the browser console on first load; register that token in the
// Firebase console (App Check → Fractals Toolkit Web → Manage debug tokens) so
// the dev environment is trusted without real reCAPTCHA attestation.
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = '12f8843d-65d7-4c4b-bbca-353b8e34e0e3';
}

// App Check — must come before getAuth/getFirestore/getFunctions so their calls
// carry an attestation token.
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6Ldy4ywtAAAAALBKMGCHur5Lfzmukm8Nl2FYKX1h"),
  isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(app);
export const db   = getFirestore(app);
export default app;
